let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bCJgs")).then(() => parcelRequire('b0ztm'));